
import { Component, Mixins } from "vue-property-decorator";
import { Point } from "../../../domain/drawing";
import { IDrawableItem, IItem, AbstractVectorItem, AbstractPointsItem, NewPageItem } from "../../../domain/document/items";
import { DragKinds } from "../DragKinds";
import { DragParameter } from "../DragParameter";
import { StandardTransformer, AspectRatioFixedTransformer } from "./transformers";
import { StandardRelocator } from "./relocators";
import { TransformerFactory } from "./TransformerFactory";

@Component({
})
export default class DraggableAreaManagerMixin extends Mixins() {
  data(): any {
    return {
      scale: 1,
    };
  }
  scale: number;

  private _previousMouseMovePickUpTimeStamp: number = 0;
  private _selectedItemPrivateId: number = -1;
  private _selectedItemClone: IDrawableItem = null;
  private _draggingParameter: DragParameter = null;

  handleMouseMovedOnDraggableArea(event: PointerEvent, items: IItem[], area: HTMLDivElement, updateItem: (i: IItem) => void) {
//    this.$logger.debug("handle mouse moved.");  // これは出したらさすがにうるさすぎる.
    if (event.buttons === 0) { return; }
    if (this._selectedItemPrivateId === null || this._selectedItemPrivateId === undefined || this._selectedItemPrivateId < 0) { return; }
    if (this._previousMouseMovePickUpTimeStamp === 0) {
      // フォーカスを当てるためにクリックしたときに、マウスが停止していないと微妙に移動してしまうので対策
      this._previousMouseMovePickUpTimeStamp = event.timeStamp + 20;
      return;
    }
    if (this._previousMouseMovePickUpTimeStamp + 10 > event.timeStamp) { return; }
    this._previousMouseMovePickUpTimeStamp = event.timeStamp;

    if (!this._selectedItemClone) {
      this._selectedItemClone = items[this._selectedItemPrivateId].clone() as IDrawableItem;
    }
    updateItem(this.isMoving()
      ? this.relocate(this._selectedItemClone, event)
      : this.transform(this._selectedItemClone, event));
  }
  
  private isMoving(): boolean {
    return (this._draggingParameter.dragKind === DragKinds.Self);
  }

  private relocate(source: IItem, event: PointerEvent): IItem {
    const location = this.toPointer(event).subtract(this._draggingParameter.offset.multiply(1 / this.scale));
    const relocator = new StandardRelocator();
    const cloned = source.clone() as IDrawableItem;
    if (cloned instanceof NewPageItem) {
      // 改ページオブジェクトは縦方向にのみ移動する
      cloned.vector = relocator.relocateVectorVertical(cloned.vector, location);
    } else if (cloned instanceof AbstractVectorItem) {
      cloned.vector = relocator.relocateVector(cloned.vector, location);
    } else if (cloned instanceof AbstractPointsItem) {
      cloned.points = relocator.relocatePoints(cloned.points, location);
    } else {
      cloned.geometry.rectangle = relocator.relocateRectangle(cloned.geometry.rectangle, location);
    }
    return cloned;
  }

  private toPointer(event: PointerEvent): Point {
    const page = this.$refs.page as HTMLDivElement;
    const pageRect = page.getBoundingClientRect();
    return new Point(
      event.clientX + page.scrollLeft - pageRect.left,
      event.clientY + page.scrollTop - pageRect.top,
    ).multiply(1 / this.scale);
  }

  private transform(source: IItem, event: PointerEvent): IItem {
    const configuration = this.$configuration.behavior.document.editor.handles.resize.modifierKeyAssign;
    const factory = new TransformerFactory({
      shift: configuration.shift,
      control: configuration.control,
      alt: configuration.alt,
    });    
    const transformer = this._draggingParameter.isAspectRatioFixed
      ? factory.create(event, new AspectRatioFixedTransformer(new StandardTransformer()))
      : factory.create(event);
    const pointer = this.toPointer(event);
    const cloned = source.clone() as IDrawableItem;
    if (cloned instanceof AbstractVectorItem) {
      cloned.vector = transformer.transformVector(cloned.vector, pointer, this._draggingParameter.dragKind);
    } else if (cloned instanceof AbstractPointsItem) {
      cloned.points = transformer.transformPoints(cloned.points, pointer, this._draggingParameter.dragKind);
    } else {
      cloned.geometry.rectangle = transformer.transformRectangle(cloned.geometry.rectangle, pointer, this._draggingParameter.dragKind);
    }
    return cloned;
  }

  handleCapturedMouseDownOnDraggableArea(event: PointerEvent) {
    this.$logger.debug("handle captured mouse down.");
    this._selectedItemPrivateId = -1;
  }

  handleMouseLeavedOnDraggableArea(event: PointerEvent) {
    this.$logger.debug("handle mouse leaved.");
    this._selectedItemPrivateId = -1;
  }

  draggableItemHandleSelected(item: IDrawableItem, param: DragParameter): void {
    this.$logger.debug("draggable item handle selected.(" + item.privateId + ", " + param.dragKind.toString() + ")");
    this._selectedItemPrivateId = item
      ? item.privateId
      : -1;
    this._selectedItemClone = null;
    this._draggingParameter = param;
    this._previousMouseMovePickUpTimeStamp = 0;
  }
}
